document.addEventListener('DOMContentLoaded', function () {
  var root = document.querySelector('.main-blog');
  var pages = document.querySelector('[data-uvi-blog-pages]');
  if (!root || !pages) return;

  var grid = root.querySelector('[data-uvi-blog-grid]');
  var heading = root.querySelector('[data-uvi-blog-heading]');
  var articles = pages.querySelectorAll('[data-uvi-blog-article]');
  var listingTitle = document.title;

  function apply() {
    var handle = (window.location.hash || '').replace(/^#/, '');
    var match = null;

    articles.forEach(function (el) {
      var on = el.getAttribute('data-uvi-blog-article') === handle;
      el.classList.toggle('is-active', on);
      if (on) match = el;
    });

    var showArticle = Boolean(match);
    root.classList.toggle('is-article', showArticle);
    if (grid) grid.hidden = showArticle;
    if (heading) heading.hidden = showArticle;

    if (match) {
      var title = match.getAttribute('data-title');
      if (title) document.title = title + ' – UVI Collection';
      window.scrollTo(0, 0);
    } else {
      document.title = listingTitle;
    }
  }

  window.addEventListener('hashchange', apply);
  apply();
});
